import Nav from "../components/general/Nav";
import Hero from "../components/blog/Hero";
import BlogList from "../components/blog/BlogList";
import ToTeam from "../components/blog/ToTeam";

import { CursorContextProvider, Cursor } from "../components/general/Cursor";
// import DemoCountdown from "../components/countdown/DemoCountdown";

function Blog() {
  return (
    <CursorContextProvider>
      <Cursor />
      {/* <DemoCountdown /> */}
      <Hero />
      <BlogList />
      <ToTeam />
      <Nav color={0} home={1} />
    </CursorContextProvider>
  );
}

export default Blog;
